import {lanesFormMenuItems, regionTypeTranslateObj} from "../../../utils/lanes-form-utils.js";
import {LanesListIcons} from "../../lanes-list/components/lanes-list-ui.jsx";
import {ImageTypeEnum, OcrEnum} from "../../../utils/lanes-utils.js";
import {FaCircle} from "react-icons/fa";
import {useRequiredTabErrors} from "../../../../../../hooks/use-required-tab-errors.js";
import React, {useEffect, useState} from "react";
import {getAssetPath} from "../../../../../../utils/get-asset-path.js";
import Alert from "../../../../../../components/alert/alert.jsx";

const FALLBACK_IMAGE = getAssetPath("img/no-img.png");

export const LanesFormMenu = ({ activatedMenus = [], currentTab, setCurrentTab, thumbnailSrc, hasChanges, className = "" }) => {
  const [hasThumbnailError, setHasThumbnailError] = useState(false);

  const {hasRequiredTabError} = useRequiredTabErrors({
    tabKeys: activatedMenus,
    tabSelected: currentTab,
    setTabSelected: setCurrentTab,
  });

  useEffect(() => {
    setHasThumbnailError(false);
  }, [thumbnailSrc]);

  const imageSrc = thumbnailSrc && !hasThumbnailError ? thumbnailSrc : FALLBACK_IMAGE;

  return (
    <div className={`bg-[#E8E8E8] border border-[#00000020] p-2 rounded flex flex-col gap-1 ${className}`}>

      <div
        className="h-auto w-full aspect-[168/95] rounded border border-[#e0e0e0] bg-white bg-contain bg-center bg-no-repeat"
        style={{backgroundImage: "url(" + imageSrc + ")"}}
      >
        {thumbnailSrc && !hasThumbnailError && <img className="hidden" src={thumbnailSrc} alt="" onError={() => setHasThumbnailError(true)}/>}
      </div>

      {lanesFormMenuItems
        .filter(el => activatedMenus.includes(el.value))
        .map(el => (
          <div key={el.value} className={`box-border cursor-pointer rounded p-1 hover:bg-(--blue-dark) hover:text-white ${currentTab === el.value ? "bg-(--blue-dark) text-white" : ""} ${hasRequiredTabError(el.value) ? "border border-[#dc2626]" : ""}`}
            onClick={() => setCurrentTab(el.value)}
          >
            <span className="font-bold text-[14px]">{el.label}</span>
          </div>
        ))
      }
      {hasChanges &&
        <Alert target="warning" className="mt-auto">
          <span className={"text-[14px]"}>* Salve suas alterações antes de sair</span>
        </Alert>
      }
    </div>
  );
};

export const columnDefsCapturePlace = [
  {headerName: "Nome", field: "description", flex: 6, filter: true, sort: "asc"},
  {headerName: "Móvel", field: "mobile", flex: 1,
    cellRenderer: ({value}) =>
      <div className="flex items-center justify-center h-full w-full">{value ? <LanesListIcons icon="statusTrue"/> : <LanesListIcons color="#ce1515"/>}</div>
  },
];

export const columnDefsRoute = [
  {headerName: "Nome", field: "description", flex: 1, filter: true, sort: "asc"},
  {headerName: "Tipo", field: "regionType", flex: 1,
    valueGetter: (({data}) => regionTypeTranslateObj[data.regionType] ?? data.regionType)
  },
];

export const ocrOptions = [
  {value: "DISABLED", label: <div className="flex gap-1 items-center"><LanesListIcons/><span className="truncate">- Desligado</span></div>},
  {value: "SUPPLEMENT", label: <div className="flex gap-1 items-center"><LanesListIcons icon={OcrEnum.SUPPLEMENT}/><span className="truncate">- Complementar</span></div>},
  {value: "OVERWRITE", label: <div className="flex gap-1 items-center"><LanesListIcons icon={OcrEnum.OVERWRITE}/><span className="truncate">- Sobrepor</span></div>},
]

export const imageOptions = [
  {value: ImageTypeEnum.ALL, label: <div className="flex gap-1 items-center"><LanesListIcons icon={ImageTypeEnum.ALL}/><span className="truncate">- Todas</span></div>},
  {value: ImageTypeEnum.TRAFFIC, label: <div className="flex gap-1 items-center"><LanesListIcons icon={ImageTypeEnum.TRAFFIC}/><span className="truncate">- Infrações</span></div>},
  {value: ImageTypeEnum.DEMAND, label: <div className="flex gap-1 items-center"><LanesListIcons icon={ImageTypeEnum.DEMAND}/><span className="truncate">- Sob demanda</span></div>},
  {value: ImageTypeEnum.NONE, label: <div className="flex gap-1 items-center"><LanesListIcons/><span className="truncate">- Nenhuma</span></div>},
]

export const MandatoryFieldMessage = ({fields, setup}) => {
  const order = {
    "capturePlace": {order: 0, label: "Ponto de coleta:"},
    "route": {order: 1, label: "Sentido:"},
    "lane": {order: 2, label: "Câmera:"},
    "forward": {order: 3, label: "Câmera dianteira:"},
    "back": {order: 4, label: "Câmera traseira:"},
  }

  const titles = [...new Set(fields.map(el => el.origin))].sort((a, b) => {
    const orderA = order[a]?.order ?? 99;
    const orderB = order[b]?.order ?? 99;
    return orderA - orderB;
  });

  return(
    <div>
      {titles.map(el =>
        <div key={el}>
          <h3>{order[el].label}</h3>
          {fields.filter(item => item.origin === el).map((field, index, arr) => <span key={`${field.origin}-${field.label}-${index}`}>{field.label}{(index+1) === arr.length ? "" : ", " }</span>)}
        </div>
      )}
    </div>
  )
}

export const ChangeRouteLaneList = ({list}) => {

  return(
    <div className="flex flex-col gap-2">
      <span>A alteração no sentido irá impactar em outras câmeras. Câmeras impactadas:</span>
        <ul className="max-h-[80px] text-[13px] border border-[#d3d3d3] border-radius-[5px] px-2 overflow-y-auto">
          {list.map(el =>
            <li key={el} className="text-left flex items-center gap-1 mt-2 *:first:mt-0!"><FaCircle size={7}/>{el}</li>
          )}
        </ul>
      <span>Deseja continuar?</span>
    </div>
  )
}
